document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-ng-category]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const drawer = link.closest('header-drawer, menu-drawer');
  if (drawer && typeof drawer.closeMenuDrawer === 'function') {
    const summary = drawer.querySelector('summary');
    drawer.closeMenuDrawer(event, summary);
    summary?.setAttribute('aria-expanded', 'false');
  }
  const menu = link.closest('header-menu');
  if (menu) {
    menu.querySelector('details')?.removeAttribute('open');
    menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }
});
